import {
  usePracticeHistoryQuery,
  usePracticeQuery,
  usePracticeLogoQuery,
} from '@common/cache';
import { useContext, useEffect, useState } from 'react';
import { AdminPanelDrawerContext } from '@views/pages/Admin/context';

interface IUsePracticeItemProps {
  id: string;
  handleClose: () => void;
}

const historyTabIndex = '2';

export const usePracticeItem = ({ id, handleClose }: IUsePracticeItemProps) => {
  const [historyPage, setHistoryPage] = useState(1);
  const {
    isFormClean,
    handleClear,
    handleCloseTrigger,
    tabIndex,
    handleTriggerChangeTab,
    triggerClose,
  } = useContext(AdminPanelDrawerContext);

  const practice = usePracticeQuery({
    practice_id: id,
  });

  const practiceHistory = usePracticeHistoryQuery({
    practice_id: id,
    page: historyPage,
    limit: 100,
    enabled: historyTabIndex === tabIndex,
  });

  const fetchedLogo = usePracticeLogoQuery({
    practice_id: id,
  });

  useEffect(() => {
    if (isFormClean && triggerClose) {
      handleClose();
      handleClear();
    }
  }, [isFormClean, triggerClose]);

  return {
    fetchedLogo,
    practice,
    tabIndex,
    handleTriggerChangeTab,
    practiceHistory: practiceHistory.data,
    historyPage,
    setHistoryPage,
    handleCloseTrigger,
    historyTabIndex,
  };
};
